module.exports = __webpack_public_path__ + "static/media/ic_pencil_white.65e314fe.svg";